// Fuente unica de queryKeys de React Query para el modulo de accesos
// (lista de usuarios autorizados / whitelist). Jerarquia por prefijo:
//   ['accesos','lista', hq] -> el listado completo
export const accesosKeys = {
  all: ['accesos'],
  lista: (hq) => ['accesos', 'lista', hq],
};

export default accesosKeys;
